// extracted by mini-css-extract-plugin
module.exports = {"container":"Jumio__container--1ZH","title":"Jumio__title--2nu","description":"Jumio__description--39m","button":"Jumio__button--ftF"};